import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";
import {Application_Updated, eventBus} from "@/state";

export var SetApplicationSmsConsentMutation = gql`
  mutation setApplicationSmsConsent($organizationId: UUID!, $applicationId: UUID!, $consent: Boolean!) {
    setApplicationSmsConsent(organizationId: $organizationId, applicationId: $applicationId, consent: $consent) 
  }
`;

export function apiSetApplicationSmsConsent(organizationId, applicationId, consent) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");
        if(!applicationId) reject("applicationId is required");

        client
            .mutate({
                mutation: SetApplicationSmsConsentMutation,
                variables: {organizationId, applicationId, consent},
                fetchPolicy: "network-only"
            })
            .then((result) => {
                eventBus.next({type: Application_Updated});
                resolve(result.data.setApplicationSmsConsent);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to update SMS consent");
                reject(err);
            })
    });
}
